import prop from 'ramda/src/prop';
import authenticationSelector from 'root/src/client/logic/auth/selectors/authenticationSelector';
import { getCookie } from 'root/src/client/v2/browser/helpers/cookies';
export function parentUserIdSelector(state) {
    return getCookie('parentUserId') || prop('parentUserId', authenticationSelector(state));
}
